import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import api from 'api/api';

import { ReleaseVersion, ReleaseVersionMap } from '../types';
import { reduceVersionsToMap } from '../utils';

const fetchReleaseVersions = async () => {
  const { data } = await api.get(`/web/versions`);

  return data;
};

export const useRawReleaseVersions = <T = ReleaseVersionMap>(
  opts?: Omit<UseQueryOptions<ReleaseVersion[], AxiosError, T>, 'queryKey' | 'queryFn'>
) => {
  return useQuery<ReleaseVersion[], AxiosError, T>({ queryKey: ['releaseVersions'], queryFn: fetchReleaseVersions, ...opts });
};

const useReleaseVersions = (
  opts?: Omit<UseQueryOptions<ReleaseVersion[], AxiosError, ReleaseVersionMap>, 'queryKey' | 'queryFn'>
) => {
  return useRawReleaseVersions<ReleaseVersionMap>({ select: reduceVersionsToMap, ...opts });
};

export default useReleaseVersions;
